// src/Admin/custom_hooks/useFieldsFromCache.ts (or .js)
import { gql, useApolloClient } from "@apollo/client";

const GET_FIELDS = gql`
  query GetFields($Table_Key: String!) {
    GetUserTableColumnManagementWithUserId_Page_ID(Table_Key: $Table_Key) {
      Field_Name
      Status
    }
  }
`;

export const useFieldsFromCache = (Key) => {
  const client = useApolloClient();

  try {
    const cachedData = client.readQuery({
      query: GET_FIELDS,
      variables: { Table_Key: Key },
    });

    const fields =
      cachedData?.GetUserTableColumnManagementWithUserId_Page_ID?.filter(
        (item) => item?.Status
      ).map((item) => item?.Field_Name) || [];

    return fields;
  } catch (err) {
    console.warn("Cache miss or error reading from cache", err);
    return [];
  }
};
